module.exports = __webpack_public_path__ + "img/gs1.928e5031.png";